module.exports = __webpack_public_path__ + "img/12.91fdd255.jpg";